import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6a7s6uk3pz: FaireBrandEntity = {
  token: "b_6a7s6uk3pz",
  type: "brand",
  name: "Cabana Club California",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b51bf1e70b44227b45de27fed7e78646f2960fba145c25acf3c8e0ae073d415.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d09a6a5423148fceec2b77d5e3c57cbaf1565577cdb7e39aeaf446afc138aeee.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7b51bf1e70b44227b45de27fed7e78646f2960fba145c25acf3c8e0ae073d415.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d09a6a5423148fceec2b77d5e3c57cbaf1565577cdb7e39aeaf446afc138aeee.jpeg",
  location: "San Clemente, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 16,
  isInsider: true,
  description:
    "Your Seaside Clubhouse Awaits\n\nBorn from sunshine and shaped by the sea, Cabana Club California is a surfy, feel-good brand unlike anything else. We make sunshine you can wear; colorful, playful pieces designed to feel like your favorite day at the beach.\n\nThis is a clubhouse for free spirits, surfers and for anyone who still believes life is better with salt in their hair and sand between their toes.\n\nWhat We Make\n\nEvery Cabana Club drop feels like a keepsake from a place you never wanted to leave.\n\t•\tCustom Merch\nOne-of-a-kind, club-style pieces made to stand out and have fun.\n\t•\tOriginal Designs\nCreated on the California coast and inspired by surf culture, sunny days, and the simple magic of being near the ocean.\n\t•\tUpcycled with Love\nReworked classics brought back to life with raw edges, coastal details, and laid-back California soul.\n\nOur pieces are made in small batches, designed and finished in California, with an emphasis on creativity, quality, and fun.\n\nThe Vibe\n\nThis isn’t just a brand.\nIt’s your seaside  clubhouse.\n\nA place for the color-happy and salt-hearted.\nA love letter to the coast, written in stripes.\n\nWe believe clothes should make you smile, feel good, and remind you to enjoy the ride.\n\nCabana Club California\nMade for sunshine. Built for fun. Always coastal.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:41.109Z",
    importedBy: "entity-db-cli",
  },
};
